const solicitudEditarEliminacionState = {
  modalSolicitudEditarEliminacion: false,
  detallePrestacion: {
    codigoPrestacionPrestador: null,
    tipoPrestacion: null,
    pabellonPrestacion: null,
    glosaPrestacionPrestador: null,
    glosaGrupoPrestador: null,
    inicioVigenciaArancel: null,
    inicioVigenciaArancelError: "",
    codigoFonasa: null,
    itemImed: null,
    tipoProfesional: null,
    tipoUnidad: null,
    // grupoPrestacionIsapre: null,
    // codigoPrestacionIsapre: null,
    // glosaPrestacionIsapre: null,
    montoArancelPrestacion: null,
    tipoAtencion: null,
    glosaTipoArancel: null,
    glosaCentroAtencion: null,
    rowGuid: null,
  },
};

export default solicitudEditarEliminacionState;
